var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9698477_verify_icon",
    "data-name": "9698477_verify_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.996,
    viewBox: "0 0 16 15.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M9.98,13.55a.557.557,0,0,1-.394-.164l-1.8-1.8a.558.558,0,0,1,.789-.789L9.98,12.2l3.2-3.2a.558.558,0,0,1,.789.789l-3.594,3.594A.557.557,0,0,1,9.98,13.55Z",
    transform: "translate(-2.886 -3.194)",
    fill: "#34a853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M9.25,17.246a2,2,0,0,1-1.3-.469L6.773,15.766a1.141,1.141,0,0,0-.573-.208H4.92a1.994,1.994,0,0,1-1.994-1.994V12.291a1.115,1.115,0,0,0-.208-.565l-1-1.183a2.05,2.05,0,0,1,0-2.582l1-1.183a1.115,1.115,0,0,0,.208-.565V4.933A1.994,1.994,0,0,1,4.92,2.939H6.207a1.215,1.215,0,0,0,.573-.208L7.956,1.719a2.032,2.032,0,0,1,2.6,0l1.176,1.012a1.141,1.141,0,0,0,.573.208h1.265A1.994,1.994,0,0,1,15.56,4.933V6.2a1.15,1.15,0,0,0,.216.573l1.012,1.176a2.032,2.032,0,0,1,0,2.6l-1.012,1.176a1.15,1.15,0,0,0-.216.573v1.265a1.994,1.994,0,0,1-1.994,1.994H12.3a1.215,1.215,0,0,0-.573.208L10.552,16.77A1.968,1.968,0,0,1,9.25,17.246ZM4.92,4.055a.88.88,0,0,0-.878.878V6.205a2.188,2.188,0,0,1-.476,1.287l-1,1.183a.927.927,0,0,0,0,1.138l1,1.183a2.207,2.207,0,0,1,.476,1.287v1.272a.88.88,0,0,0,.878.878H6.207a2.191,2.191,0,0,1,1.3.484l1.176,1.012a.938.938,0,0,0,1.146,0l1.176-1.012a2.24,2.24,0,0,1,1.3-.484h1.265a.88.88,0,0,0,.878-.878V12.291a2.191,2.191,0,0,1,.484-1.3l1.012-1.176a.938.938,0,0,0,0-1.146L14.935,7.492a2.191,2.191,0,0,1-.484-1.3V4.933a.88.88,0,0,0-.878-.878H12.308a2.191,2.191,0,0,1-1.3-.484L9.831,2.559a.938.938,0,0,0-1.146,0L7.509,3.579a2.251,2.251,0,0,1-1.3.476Z",
    transform: "translate(-1.256 -1.25)",
    fill: "#34a853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verify-icon.cf06b3ddde1a0cec28b0a798afd5c890.svg";
export { ForwardRef as ReactComponent };